import {useEffect, useState} from "react";
import {useDrawer} from "../../redux/Reducers/DrawerReducer";
import {useNavigate} from "react-router-dom";
import SideBarIcon from "../Icon/SideBarIcon";
import {IoIosArrowDown, IoIosArrowUp} from "react-icons/io";
import {useDispatch, useSelector} from "react-redux";
import axiosInstance from "../../API/Axios/AxiosConfig";
import URLS from "../../API/Axios/URLS";
import {setGuide} from "../../redux/Reducers/GuideSlice";


export default function GuideDropDown({className, ...props}) {
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(false)
    const {actions} = useDrawer();
    const naviations = useNavigate();
    const dispatch = useDispatch()
    const guides = useSelector(state => state.GuideSlice)
    useEffect(() => {
        axiosInstance.get(URLS.getGuideList).then((res) => {
            dispatch(setGuide(res.data?.data))
        }).catch((error) => {
            console.log(error)
        })
    }, [])

    function handleDropdownMenuClick() {
        setIsDropdownMenuOpen(!isDropdownMenuOpen)
    }

    console.log()

    return (

        <li className="relative px-6 py-3">

            <div
                className="inline-flex  justify-between w-full text-base font-semibold

                 transition-colors duration-150 hover:text-gray-800 dark:text-gray-100 dark:hover:text-gray-300"
                onClick={handleDropdownMenuClick}

            >
                <SideBarIcon name={"guide"}/>
                <div className="flex flex-col self-center justify-center items-center flex-1">
                    <div className="w-full inline-flex items-center  flex-1">
                        <p className="ml-4 cursor-pointer mr-2">Guide</p>
                        {
                            !isDropdownMenuOpen ?
                                <IoIosArrowDown onClick={() => setIsDropdownMenuOpen(!isDropdownMenuOpen)}
                                                className="w-4 h-4 cursor-pointer ml-1 " aria-hidden="true"/> :
                                <IoIosArrowUp onClick={() => setIsDropdownMenuOpen(!isDropdownMenuOpen)}
                                              className="w-4 h-4 cursor-pointer ml-1 " aria-hidden="true"/>
                        }

                    </div>
                    {isDropdownMenuOpen && (
                        <div className={"ml-6 mt-4 gap-2 w-full   font-semibold flex flex-col"}>
                            {
                                Object.keys(guides).map((key, index) => {

                                    return (
                                        <div
                                            key={index}

                                            className={" text-md mb-2   text-black w-full first-letter:uppercase"}
                                        >
                                            <p className={"text-gray-400 my-1 text-base"}>{key}</p>
                                            {
                                                guides[key]?.map((guideData, index) => {
                                                    return (
                                                        <div
                                                            onClick={() => {
                                                                naviations(`/guide/${guideData?.title}`)
                                                                actions.closeDrawer()
                                                            }}
                                                            key={guideData?.title || index * 100}
                                                             className={"cursor-pointer   w-full first-letter:uppercase"}>
                                                            {guideData?.title}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )}
                </div>


            </div>

        </li>

    )
}